<template>
  <div class="binding-info">
    <div class="info-header">
      <div class="title">请绑定您的手机号</div>
    </div>
    <div class="info-main">
      <div class="form-wrapper">
        <div class="form-hits">*为必填项</div>
        <el-form :model="userForm" :rules="userRules" ref="userForm">
          <div class="fieldset">
            <div class="field-row">
              <el-form-item prop="mobile" class="mobile">
                <el-input v-model.trim="userForm.mobile" maxlength="11" placeholder="* 请输入您的手机号"></el-input>
              </el-form-item>
            </div>
            <div class="field-row two-field">
              <el-form-item prop="imgCode" class="two-l">
                <el-input v-model.trim="userForm.imgCode" placeholder="* 请输入图形验证码"></el-input>
              </el-form-item>
              <el-form-item class="two-r smsCodeImg">
                <img class="two-r smsCodeImg" @click="refreshCode" :src="captchaImg" />
              </el-form-item>
            </div>
            <div class="field-row two-field">
              <el-form-item prop="smsCode" class="two-l">
                <el-input v-model.trim="userForm.smsCode" placeholder="* 请输入手机验证码"></el-input>
              </el-form-item>
              <el-form-item class="two-r">
                <el-button class="btn" :disabled="smsStatus" @click="sendSMS">发送验证码{{`${countdown?'('+countdown+'s)':''}`}}</el-button>
              </el-form-item>
            </div>
          </div>
          <div class="form-actions">
            <div class="isdefault" @click="switchPrivacy">
              <i :class="['iconfont', agree? 'checked' : '']">{{agree ? '&#xedaf;' : '&#xec58;'}}</i>
              <span>我已仔细阅读并同意 鬼塚虎<router-link to="/privacy-policy?active=0" target="_blank">隐私政策</router-link></span>
            </div>
            <el-button class="new-address" :disabled="saveStatus" @click="bindingInfo">确认</el-button>
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import types from "@/store/types";
import api from "@/utils/api";
import { captureManualError } from '@/sentry/index'

export default {
  data() {
    return {
      now: Date.now(),
      captchaImgSrc: api[types.CAPTCHA](),
      countdown: 0,
      code: '',
      userForm: {
        mobile: '',
        imgCode: '',
        smsCode: '',
      },
      userRules: {
        mobile: [{
          validator(fieldRule, value, callback) {
            if (!value) {
              callback(new Error("请输入手机号码"));
            } else if (!/^1[3456789]\d{9}$/.test(value)) {
              callback(new Error("请输入正确的手机号码"));
            } else {
              callback();
            }
          }, trigger: "blur"
        }],
        imgCode: [{ required: true, message: "请输入图形验证码", trigger: "blur" }],
        smsCode: [{ required: true, message: "请输入手机验证码", trigger: "blur" }]
      },
      agree: true
    }
  },
  created() {
    let { code: authCode, returnUrl } = this.$route.query;
    if (authCode) {
      this.authCode = authCode;
      this.returnUrl = returnUrl;
    } else {
      this.$router.replace({path: '/'});
    }
  },
  methods: {
    refreshCode() {
      this.now = Date.now();
    },
    switchPrivacy() {
      this.agree = !this.agree;
    },
    sendSMS() {
      api[types.SEND_SMS]({
        mobile: this.userForm.mobile,
        imgCode: this.userForm.imgCode,
        type: "bind"
      }).then(res => {
        if (res?.code == 1) {
          this.runCountdown(60, (time) => {
            this.countdown = time;
          });
        } else {
          console.warn(res);
        }
      }).catch(err => {
        console.warn(err);
        captureManualError(err)
      });
    },
    runCountdown(times, callback) {
      if (isNaN(times)) callback("倒计时定时器时间设置错误");
      callback(times);
      let timer = setInterval(() => {
        --times;
        callback(times, timer);
        if (times == 0) clearInterval(timer);
      }, 1000);
    },
    bindingInfo() {
      let returnUrl = decodeURIComponent(this.returnUrl || '/');
      this.$refs.userForm.validate(valid => {
        if (valid) {
          let newArgs = {
            mobile: this.userForm.mobile,
            code: this.userForm.smsCode,
            authCode: this.authCode
          };
          api[types.BIND_USER_INFO](newArgs).then(res => {
            // code: 0: 失败, 1: 用户已注册, 2: 全局已过期, 3: 用户未注册, 4: 授权码过期
            let { code, data } = res;
            if (code == 1) {
              this.$store.commit(types.LOGIN, data.token);
              this.$store.dispatch(types.GET_PROFILE);
              // 先合并游客购物车, 完成后再拉取用户购物袋(并行会有时序竞态, 把未合并数据写回)
              this.$store.dispatch(types.MERGE_CART).finally(() => {
                this.$store.dispatch(types.GET_CART_INFO);
              });
              this.$router.replace({ path: returnUrl });
            } else if (code == 3) {
              this.$router.replace({ path: `/user/register?authCode=${this.authCode}&mobile=${this.userForm.mobile}&returnUrl=${returnUrl}`});
            } else if (code == 4) {
              this.$message({ message: "授权码过期", type: "warning" });
              if (data.type == "wx" || data.type == "sina") {
                location.href = `${api.API_PATH.replace(/api\/$/, '')}${data.type}/login&returnUrl=${returnUrl}`;
              } else {
                console.warn(`未知第三方登录渠道：${data.type}`);
              }
            } else {
              // this.$message({ message: res.message, type: "warning" });
            }
          }).catch(err => {
            console.warn(err);
            captureManualError(err)
          });
        }
      });
    }
  },
  computed: {
    captchaImg() {
      return `${this.captchaImgSrc}?t=${this.now}`;
    },
    smsStatus() {
      if (this.countdown) return true;
      let { mobile, imgCode } = this.userForm;
      if (/^1[3456789]\d{9}$/.test(mobile) && imgCode) {
        return false;
      }
      return true;
    },
    saveStatus() {
      let { mobile, imgCode, smsCode } = this.userForm;
      if (/^1[3456789]\d{9}$/.test(mobile) && imgCode && smsCode && this.agree) {
        return false;
      }
      return true;
    }
  }
};
</script>

<style lang="scss" scoped>
  .binding-info {
    box-sizing: border-box;
    max-width: 1200px;
    margin: 0 auto;
    .info-header {
      padding: 60px 0 20px 0;
      font-size: 20px;
      font-weight: 700;
      color: #222222;
    }
    .info-main {
      .form-wrapper {
        box-sizing: border-box;
        width: 470px;
        max-width: 100%;
        margin: 0 auto;
        padding: 0 65px;
        .form-hits {
          font-size:14px;
          font-weight:400;
          color:rgba(127,0,25,1);
          text-align: right;
          margin-bottom: 10px;
        }
        .fieldset {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          .field-row {
            width: 100%;
            display: flex;
            justify-content: space-between;
            &.two-field {
              .two-l {
                width: calc(100% - 155px);
              }
              .two-r {
                width: 135px;
                &.smsCodeImg { cursor: pointer; }
                .btn {
                  padding: 0; width: 100%; font-size: 14px; color: #999; background: #FFFFFF; border: 1px solid #CCC;
                  &[disabled], &[disabled]:hover { color: #666; background: #E7E7E7; border: 1px solid #DCDFE6; cursor: not-allowed; }
                }
                img { width: 100px; height: 40px; margin: 0 auto; }
              }
            }
            .mobile { width: 100%; }
          }
        }
        .form-actions {
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          align-items: flex-start;
          .isdefault {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            .iconfont { color: #CCC; cursor: pointer; }
            .iconfont.checked { color: #000; }
            span {
              height: 14px;
              font-size: 14px;
              font-weight:400;
              color: rgba(51,51,51,1);
              line-height: 14px;
              cursor: pointer;
              a {
                margin-left: 5px;
                text-decoration: underline;
              }
            }
          }
          .new-address {
            margin: 20px 0 40px 0;
            width: 100%;
            height: 40px;
            font-size: 14px;
            font-weight: 500;
            // line-height: 40px;
            color:rgba(255,255,255,1);
            background:#7f0019;
            cursor: pointer;
            &[disabled] { opacity: 0.2; cursor: not-allowed; }
          }
          .cancel-address {
            width: 157px;
            height: 40px;
            font-size: 14px;
            font-weight: 500;
            line-height: 40px;
            color:rgba(102,102,102,1);
            background: #FFF;
            border:1px solid rgba(231,231,231,1);
            cursor: pointer;
          }
        }
      }
    }
  }
</style>